import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import BooleanField from '@shared/fields/boolean-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import ImagesField from '@shared/fields/images-field';
import { UserField } from '@modules/auth/user-field';
import EmailsField from '@shared/fields/emails-field';
import RolesField from '@shared/fields/roles-field';
import IntegerField from '@shared/fields/integer-field';
import DecimalField from '@shared/fields/decimal-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
  return i18n(`entities.subproperty.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true
  }),
  slug: new StringField('slug', label('slug'), {}),
  region: new StringField('region', label('region'), { required: true }),
  url: new StringField('url', label('url'), {}),
  propertyId: new StringField('propertyId', label('propertyId'), {}),
  programs: new RolesField('programs', label('programs')),
  programsRequired: new RolesField('programs', label('programs'), {
    required: true,
  }),
  emails: new EmailsField('emails', label('emails'), {}),
  status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('subpropertyStatus'), { required: true }),
  country: new EnumeratorField('country', label('country'), getSharedEnumeratorField('country'), { required: true }),
  access: new EnumeratorField('access', label('access'), getSharedEnumeratorField('access'), { required: false }),
  managers: UserField.relationToMany('managers', label('managers'), {}),
  birthdateType: new EnumeratorField('birthdateType', label('birthdateType'), getSharedEnumeratorField('birthdateType'), { required: false }),
  dateFormat: new EnumeratorField('dateFormat', label('dateFormat'), getSharedEnumeratorField('dateFormat'), { required: false }),
  timeFormat: new EnumeratorField('timeFormat', label('timeFormat'), getSharedEnumeratorField('timeFormat'), { required: false }),

  paymentsEnabled: new BooleanField('paymentsEnabled', label('paymentsEnabled'), {}),
  owqloFeeFixed: new IntegerField('owqloFeeFixed', label('owqloFeeFixed'), { min: 0 }),
  owqloFeePercentage: new DecimalField('owqloFeePercentage', label('owqloFeePercentage'), { min: 0, max: 100 }),

  logo: new ImagesField(
    'logo',
    label('logo'),
    `properties/logo`,
    { max: 1, "required": true },
  ),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
};

export class SubpropertyModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
